<template>
    <span :class="`${statusClass} additionalClass`">{{ content }}</span>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            required: true
        },
        status: {
            required: true
        }
    },

    computed: {
        statusClass() {
            const statusNumberMap = {
                1: 'active',
                0: 'inactive',
                '-1': 'deleted',
                2: 'dissolved',
                6: 'six'
            }
            const statusStringMap = {
                1: 'active',
                0: 'inactive',
                '-1': 'deleted',
                2: 'dissolved',
                6: 'six'
            }

            return typeof this.status === 'number'
                ? statusNumberMap[this.status] || ''
                : typeof this.status === 'string'
                ? statusStringMap[this.status] || ''
                : ''
        }
    }
}
</script>

<style scoped>
.additionalClass {
    border-radius: 1rem;
    padding: 0.25rem 0.5rem;
}

/* Active (Xanh lá)
*/
.active {
    background-color: #D1E7DD;
    color: #157347 !important;
}

/* --- INACTIVE (Xám) --- */
.inactive {
    background-color: #E2E3E5;
    color: #5E6469 !important;
}

/* --- DELETED (Đỏ) --- */
.deleted {
    background-color: #F8D7DA;
    color: #A7343D !important;
}

/* --- DISSOLVED (Vàng) --- */
.dissolved {
    background-color: #FFF3CD;
    color: #906D08 !important;
}

/* --- SIX (Cam) --- */
.six {
    background-color: #FFE5D0;
    color: #AF5B28 !important;
}
</style>